define('plugin/promo/view/PromoView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Promo code view
     *
     * @class PromoView
     */
    return LayoutView.extend({

        template: '#promotion_input_view',
        ui: {
            input: ':input'
        },
        events: {
            'change @ui.input': 'onPromoCodeChanged'
        },
        _bookingModel: null,

        /**
         * Initializes plugin
         */
        initialize: function () {
            this._bookingModel = this.getOption('bookingModel');
        },

        /**
         * On promotion code was changed set promo code to booking model
         */
        onPromoCodeChanged: function () {
            this._bookingModel.set('promo_code', this.ui.input.val());
        },

        _getError : function () {
            var error = null;
            if (this._bookingModel.validationError && this._bookingModel.validationError.promo_code) {
                error = this._bookingModel.validationError.promo_code;
            }
            return error;
        },

        /**
         * Serialize data for view
         *
         * @return Object
         */
        serializeData: function () {
            var error = this._getError();

            return {
                value: this._bookingModel.get('promo_code'),
                error: error
            };
        },


        onDomRefresh: function () {
            var error = this._getError();

            if(error){
                Backbone.Wreqr.radio.vent.trigger('field_error', 'shown', {
                    'type': 'promo_code',
                });
            }
        }

    });

});
